<p-dialog [header]="'productsold.markProductAsSold' | transloco" [(visible)]="isProductSoldDialogVisible" [modal]="true"
  [style]="{ 'width': '560px' }" (onHide)="closeDialog()">
  @if (productSoldData) {
    <form class="form-horizontal px-2">
      <div class="d-flex mt-4">
        <img
          [src]="productSoldData.ArtistProductImgUrl ? productSoldData.ArtistProductImgUrl : 'assets/images/No-Image.png'"
          style="width: 150px;" />
          <div class="d-flex flex-column ms-3">
            <h3>{{ productSoldData.SerialNumber }} - {{productSoldData.ArtistProductName}}</h3>
            @if (productSoldData.ShortDescription) {
              <div class="text-muted">
              {{productSoldData.ShortDescription}}</div>
            }
            <!-- <div class="mt-4">
            <span class="fw-bold">Artist Revenue: </span>{{productSoldData.ArtistRevenue |
            currency:'USD':'symbol':'1.2-2'}}
          </div> -->
          @if (productSoldData.SuggestedSalePrice) {
            <div>
              <span class="fw-bold">{{ 'productsold.suggestedPrice' | transloco }} </span> {{productSoldData.SuggestedSalePrice |
              currency:'USD':'symbol':'1.2-2'}}
              @if (productSoldData.Remarks) {
                <div class="text-muted fst-italic">{{productSoldData.Remarks}}</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="soldPrice" class="form-label">{{ 'productsold.salePrice' | transloco }}</label>
        <input type="number" id="soldPrice" name="soldPrice" class="form-control" min="0"
          [placeholder]="'productsold.enterSellingPrice' | transloco" [(ngModel)]="productSoldData.ArtistRevenue " (input)="preventNegativeValues($event)"  />
        </div>
        <div class="form-group mt-2 position-relative">
          <label class="form-label mt-3">{{ 'productsold.comment' | transloco }} </label>
          <textarea id="comments" pInputTextarea rows="3" name="comments" [(ngModel)]="formData.ProductSoldComment"
            [placeholder]="'productsold.addCommentHere' | transloco" class="form-control">
          </textarea>
          <div class="emoji-icon position-absolute cursor-pointer fs-6" (click)="openEmojiDialog()"
            style="top: 55%; right: 0.5rem; transform: translateY(-50%);">
            (😍)
          </div>
          <div class="form-group mt-4">
            <button pButton type="button" [label]="'productsold.markAsSold' | transloco" class="w-100 p-button-outlined"
            (click)="markProductAsSold($event)"></button>
          </div>
        </div>
      </form>
    }
  </p-dialog>



  <!-- Emoji-Dialog -->
  @if (displayEmojiDialog) {
    <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
    (emojiClick)="addEmoji($event)"></app-emoji-list>
  }